const { InnerBlocks, RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const {
    margin,
    image,
    image2,
    numberCard,
    numberCard2,
    numberCard3,
    textCard,
    textCard2,
    textCard3,
  } = attributes;

  return (
    <div className={`GridImageText ${margin} `}>
      <div className="GridImageText__wrapper">
        <figure className="GridImageText__image">
          <img
            src={image.src}
            title={image.alt}
            width={image.width}
            height={image.height}
            alt={image.alt}
          />
        </figure>
      </div>
      <div className="GridImageText__wrapper">
        <div className="GridImageText__item">
          <RichText.Content
            className="GridImageText__item--number"
            tagName="p"
            value={numberCard}
          />
          <RichText.Content
            className="GridImageText__item--text"
            tagName="p"
            value={textCard}
          />
        </div>
        <figure className="GridImageText__image">
          <img
            src={image2.src}
            title={image2.alt}
            width={image2.width}
            height={image2.height}
            alt={image2.alt}
          />
        </figure>
      </div>
      <div className="GridImageText__wrapper">
        <div className="GridImageText__item">
          <RichText.Content
            className="GridImageText__item--number"
            tagName="p"
            value={numberCard2}
          />
          <RichText.Content
            className="GridImageText__item--text"
            tagName="p"
            value={textCard2}
          />
        </div>
        <div className="GridImageText__item">
          <RichText.Content
            className="GridImageText__item--number"
            tagName="p"
            value={numberCard3}
          />
          <RichText.Content
            className="GridImageText__item--text"
            tagName="p"
            value={textCard3}
          />
        </div>
      </div>
    </div>
  );
};

export default Save;
